module.exports = __webpack_public_path__ + "img/waimai-03.73d42673.jpg";